import refs from "../refs"
import {showBackdrop, hideBackdrop} from "../utils"

const {appointmentButtons, appointmentBackdrop, menuBackdrop, appointmentCloseButton, popup_appointment} = refs;

const handleClick = () => {
    if(!menuBackdrop.hasClass('is-hidden')){
        hideBackdrop(menuBackdrop);
    }
    showBackdrop(appointmentBackdrop);
}

appointmentButtons.on('click', handleClick)
appointmentCloseButton.on("click", () => hideBackdrop(appointmentBackdrop))




popup_appointment?.querySelector('input[type="checkbox"]')?.addEventListener('change', function(){
		if(this.checked){
				popup_appointment.querySelector('button[type="submit"]')?.removeAttribute('disabled')
		}else{
				popup_appointment.querySelector('button[type="submit"]')?.setAttribute('disabled', 'disabled')
		}
})